
import Card from 'vux/src/components/card/index.vue'

export default {
name: 'Order',
components: {
Card
},
data() {
return {
ID: '',
order: {},
orderFiles: [],
demageFiles: [],
}
},
created() {
this.ID = this.$route.query.ID || ''
this.loadData()
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getOrderFiles() {
let _this = this;
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
_this.orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
_this.demageFiles = res
});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/scts/th/Files.vue